import '@fontsource/barlow-condensed/latin-600.css';
import '@fontsource/barlow-condensed/latin-700.css';
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/jetbrains-mono/latin-400.css';
import '@fontsource/jetbrains-mono/latin-600.css';
import './ui/theme.css';
import './ui/components.css';
import './ui/screens.css';
import './ui/hud/hud.css';
import { h, render } from 'preact';
import { App } from './app';
import { Shell } from './ui/Shell';

const app = new App(document.getElementById('app')!);
render(h(Shell, { app }), app.uiRoot);
app.init().catch((err) => {
  console.error(err);
  document.body.textContent = `Failed to start: ${(err as Error).message}`;
});
